const fr = {
  welcome: "Bienvenue",
  login: "Connexion",
  logout: "Déconnexion",
  pleaseLogin: "Veuillez vous connecter",
  loginDesc: "Connectez-vous à votre compte existant sur Khadam",
  email: "Email",
  password: "Entrez votre mot de passe",
  donthaveaccount: "Vous n'avez pas de compte ?",
  contactus: "Contactez-nous",
  changelanguage: "Changer de langue",
  mail: "E-mail",
  callus: "Appelez-nous",
  stock: "Stock",
  welcomeInTo: "Bienvenue dans Khdame",
  choice: "Veuillez choisir l'opération",
  takePhoto: "Prendre une photo",
  stats: "Statistiques",
  settings: "Paramètres",
  sell: "Vendre",
  addproduct: "Ajouter un produit",
  currentversion: "Version actuelle",
  search: "Rechercher un produit",
  searchByDate: "Rechercher",
  editproduct: "Modifier",
  productavailable: "Stock",
  budget: "Budget",
  productname: "Nom du produit",
  boughtprice: "Achat",
  sellprice: "Vente",
  price: "Prix",
  develop: "Développez votre magasin avec",
  khdame: "Khdame",
  welcomedesc1: "Découvrez votre magasin avec notre application interactive",
  start: "Commencer",
  welcomedesc2: "Facile à utiliser et convivial",
  noproducts: "Aucun produit",
  noProductsWithoutBarcode: "Aucun produit sans code-barres",
  errorFetchingProducts: "Erreur lors du chargement des produits",
  addProduct: "Ajouter un produit",
  productName: "Nom du produit",
  buyPrice: "Prix d'achat",
  sellPrice: "Prix de vente",
  typeOfQuantity: "Type de quantité",
  quantity: "Quantité",
  barcode: "Code-bar",
  scanNew: "Nouveau scan",
  alreadyScanned: "Déjà scanné",
  scanProduct: "Scanner le produit",
  openCamera: "Ouvrir la caméra",
  barcodeReading: "Lecture du code-bar",
  doubleTapToFlip: "Appuyez deux fois pour retourner la caméra",
  frontCameraWarning:
    "La caméra frontale peut ne pas faire la mise au point correctement sur les codes-barres",
  useBackCamera:
    "Appuyez deux fois pour passer à la caméra arrière pour de meilleurs résultats",
  successScan: "Scan réussi",
  delete: "Supprimer",
  save: "Enregistrer",
  closeCamera: "Fermer la caméra",
  add: "Ajouter",
  clickToAdd: "Cliquer pour ajouter",
  searchError: "Erreur lors de la recherche de produits",
  cancel: "Annuler",
  currency: "DA",
  comptepersonel: "Compte Personnel",
  storeInfo: "Informations du magasin",
  updateapp: "Mettre à jour",
  storename: "Nom du magasin",
  changepassword: "Changer le mot de passe",
  changedata: "Modifier les données",
  newpassword: "Nouveau mot de passe",
  oldpassword: "Ancien mot de passe",
  confirm: "Confirmer",
  username: "Nom d'utilisateur",
  viewProfile: "Voir le profil",
  repeatPassword: "Répéter le mot de passe",
  updateNewVersion: "Mise à jour",
  period: "Période",
  tout: "Tout",
  today: "Aujourd'hui",
  yesterday: "Hier",
  mounth: "Mois",
  total: "Total",
  profit: "Bénéfice",
  year: "Année",
  nbrofsell: "Ventes",
  mailRequired: "Email requis",
  passwordRequired: "Mot de passe requis",
  usernameRequired: "Nom d'utilisateur requis",
  storeNameRequired: "Nom du magasin requis",
  passwordsNotMatch: "Les mots de passe ne correspondent pas",
  passwordCannotBeSame:
    "Le nouveau mot de passe doit être différent du mot de passe actuel",
  fillAllFields: "Veuillez remplir tous les champs",
  passwordMinLength: "Le mot de passe doit contenir au moins 5 caractères",
  passwordChangeSuccess: "Mot de passe modifié avec succès",
  changePasswordError: "Une erreur s'est produite",
  cameraPermission: "Permissions de la caméra",
  cameraPermissionRequest:
    "Nous avons besoin de votre permission pour utiliser la caméra",
  grantPermission: "Accorder la permission",
  currentPassword: "Mot de passe actuel",
  newPassword: "Nouveau mot de passe",
  confirmPassword: "Confirmer le mot de passe",
  changePassword: "Changer le mot de passe",
  invalidEmail: "Email invalide",
  showmore: "Afficher plus",
  showless: "Afficher moins",
  nobills: "Aucune facture",
  newsell: "Nouvelle vente",
  bills: "Factures",
  allbills: "Toutes les factures",
  bill: "Facture",
  searchInvoice: "Rechercher une facture",
  invoiceNumber: "Facture n°",
  older: "Plus ancien",
  customerInfo: "Informations client",
  customerName: "Nom du client",
  phone: "Téléphone",
  phoneNumber: "Numéro de téléphone",
  phoneRequired: "Numéro de téléphone requis",
  items: "Articles",
  orderSummary: "Résumé de commande",
  subtotal: "Sous-total",
  tax: "Taxe",
  discount: "Remise",
  processing: "Traitement en cours...",
  confirmPurchase: "Confirmer l'achat",
  totalAmount: "Total",
  searchForProduct: "Rechercher un produit",
  unregisteredProduct: "Produit non enregistré",
  sellWithoutScan: "Vendre sans scanner",
  addToDebtList: "Ajouter à la liste des dettes",
  new: "Nouvelle",
  scaneasy: "Scanner facilement",
  scaneasyDesc:
    "Scannez le code bar des produits pour obtenir toutes les informations et les vendre aux clients",
  welcomeIntoDesc1: "Application facile pour gérer l'inventaire des produits",
  productnotExist: "Produit non enregistré",
  manageStock: "Gérer le stock",
  next: "Suivant",
  end: "Fin",
  credit: "Dettes",
  manageStockDesc:
    "Gérez l'inventaire de vos produits simplement avec votre téléphone",
  skip: "Passer",
  usecanupatehere: "Vous pouvez modifier vos informations ici",
  contactusDesc:
    "N'hésitez pas à nous contacter pour : assistance, ouverture de compte, questions sur l'application Khadam ou les services que nous proposons par e-mail ou par téléphone.",
  nameofdetn: "Nom",
  nbrofoperations: "Nombre d'opérations",
  dateofdette: "Date de la dette",
  listofdette: "Liste des dettes",
  searchadate: "Recherche par nom ou numéro",
  adddate: "Ajouter un débiteur",
  deletedette: "Supprimer la dette",
  addnewdette: "Ajouter une nouvelle dette",
  updatdette: "Mettre à jour la dette",
  nameofdain: "Nom du débiteur",
  phonenumber: "Numéro de téléphone",
  quantityofdette: "Montant de la dette",
  fillall: "Vous devez remplir tous les champs",
  validphone: "Veuillez entrer une valeur valide",
  addsuccess: "Ajouté avec succès",
  loading: "Chargement",
  nodata: "Aucune donnée",
  paidamount: "Montant payé",
  remaining: "Restant",
  paymentStatus: "Statut de paiement",
  paid: "payé",
  billLoadingDelete: "Suppression en cours",
  sellWithout: "Vendre sans scanner",
  sellWith: "Vendre avec scanner",
  addtodeptlist: "Ajouter à la liste des dettes",
  validevalueerror: "Veuillez entrer une valeur valide",
  fourni: "Fournisseur",
  pleaseaddproducts: "Veuillez ajouter des produits",
  sellseccess: "Vente réussie",
  calender: "Date :",
  editdain: "Modifier la dette",
  errorwhilepaying: "Une erreur s'est produite lors du paiement",
  dettehasbeendeleted: "La dette a été supprimée avec succès",
  dettehasbeenpaid: "La dette a été payée avec succès",
  productdetails: "Détails du produit",
  image: "Image du produit",
  addpicture: "Ajouter une image",
  changeProfilePhoto: "Changer la photo de profil",
  profilePhotoUpdated: "Photo de profil mise à jour",
  profilePhotoFailed: "Échec de la mise à jour de la photo",
  chooseOption: "Choisir une option",
  chooseFromGallery: "Choisir depuis la galerie",
  imageSelected: "Image sélectionnée",
  noImageSelected: "Aucune image sélectionnée",
  errorsearch: "Erreur lors de la recherche",
  weekrecap: "Récapitulatif hebdomadaire",
  sellQuantity: "Quantité vendue",
  all_products: "Tous les produits",
  low_stock: "Stock faible (≤10)",
  high_value: "Valeur élevée (≥100)",
  sort_by: "Trier par:",
  name_asc: "Nom (A-Z)",
  name_desc: "Nom (Z-A)",
  price_asc: "Prix (bas à élevé)",
  price_desc: "Prix (élevé à bas)",
  stock_asc: "Stock (peu à beaucoup)",
  stock_desc: "Stock (beaucoup à peu)",
  orders: "Commandes",
  noOrders: "Aucune commande pour le moment",
  noOrdersDesc: "Les commandes de vos clients apparaîtront ici",
  orderConfirmed: "Confirmée",
  orderPending: "En attente",
  confirmOrder: "Confirmer",
  cancelOrder: "Annuler",
  deleteOrder: "Supprimer",
  orderConfirmedSuccess: "Commande confirmée",
  orderCancelledSuccess: "Commande annulée",
  orderDeletedSuccess: "Commande supprimée",
  orderError: "Erreur lors de la mise à jour",
  clientName: "Nom du client",
  clientPhone: "Téléphone",
  newOrder: "Nouvelle commande",
  newOrderMessage: "Vous avez reçu une nouvelle commande de",
  filterAll: "Toutes",
  filterPending: "En attente",
  filterConfirmed: "Confirmées",
  orderDetails: "Détails de la commande",
  product: "Produit",
  unitPrice: "Prix unitaire",
  totalPrice: "Prix total",
  orderDate: "Date de commande",
  status: "Statut",
  actions: "Actions",
  clientLocation: "Emplacement du client",
  close: "Fermer",
  scanner: "Scanner",
  statistics: "Statistiques",
  scannerwithout: "Scanner sans produit",
  welcomeTitle: "Bienvenue dans votre service",
  welcomeDescription:
    "Application simple pour gérer votre magasin. Organisez les ventes, le stockage et les statistiques avec juste votre téléphone",
  scannerTitle: "Vendre avec scanner",
  scannerDescription:
    "Gérez facilement les ventes en scannant les produits dans chaque opération de vente",
  inventoryTitle: "Gestion d'inventaire",
  inventoryDescription:
    "Organisez votre inventaire facilement via l'application où vous pouvez ajouter vos produits et voir les quantités disponibles à tout moment.",
  register: "S'inscrire",
  createAccount: "Créer un compte",
  signup: "S'inscrire",
  signupTitle: "Créer un compte",
  registrationSuccessful: "Inscription réussie ! Bienvenue",
  storeName: "Nom du magasin",
  storeDescription: "Description du magasin",
  defaultStoreDescription: "Écrivez une brève description de votre magasin...",
  alreadyHaveAccount: "Vous avez déjà un compte ?",
  signIn: "Se connecter",
  loginTitle: "Connexion",
  forgotPassword: "Mot de passe oublié ?",
  orContinueWith: "Ou continuer avec",
  googleSignIn: "Continuer avec Google",
  googleSignInError: "Erreur de connexion Google",
  googleSignInCancelled: "Connexion Google annulée",
  language: "Langue",
  emailAlreadyExists: "L'email existe déjà !",
  totalsells: "Total des ventes",
  totalrevenue: "Chiffre d'affaires total",
  totalprofit: "Profit total",
  totalcapital: "Capital total",
  updateSuccess: "Modification réussie",
  updateFailed: "Échec de la modification",
  priceValidation: "Le prix de vente doit être supérieur au prix d'achat",
  searchProduct: "Rechercher un produit",
  editProduct: "Modifier le produit",
  deleteProduct: "Supprimer le produit",
  confirmDelete: "Êtes-vous sûr de vouloir supprimer ce produit ?",
  deleteMessage:
    "Êtes-vous sûr de vouloir supprimer cette facture ? Cette action ne peut pas être annulée.",
  productDeleted: "Produit supprimé avec succès",
  deleteFailed: "Échec de la suppression",
  stockManagement: "Gestion du stock",
  addNewProduct: "Ajouter un nouveau produit",
  loginSuccess: "Connexion réussie",
  whatsapp: "WhatsApp",
  facebook: "Facebook",
  instagram: "Instagram",
  website: "Site Web",
  call: "Appeler",
  emailContact: "E-mail",
  enterUsername: "Entrez le nom d'utilisateur",
  usernameOrEmail: "Nom d'utilisateur ou Email",
  enterUsernameOrEmail: "Entrez votre nom d'utilisateur ou email",
  usernameOrEmailRequired: "Nom d'utilisateur ou email requis",
  enterStoreName: "Entrez le nom du magasin",
  enterPhoneNumber: "Entrez le numéro de téléphone",
  enterStoreLocation: "Entrez l'emplacement du magasin",
  imageSizeError: "La taille de l'image doit être inférieure à 600 KB",
  loadProductsError: "Erreur lors du chargement des produits",
  quantityUpdated: "Quantité mise à jour avec succès",
  enterValidQuantity: "Veuillez entrer une quantité valide",
  notEnoughStock: "Pas assez de stock disponible",
  productAddedSuccess: "Produit ajouté avec succès",
  enterValidValue: "Veuillez entrer une valeur valide",
  deleteSuccess: "Supprimé avec succès",
  deleteError: "Erreur lors de la suppression",
  noProductsFound: "Aucun produit trouvé",
  searchProductsError: "Erreur lors de la recherche de produits",
  scanSuccess: "Scan réussi",
  productNotFound: "Produit non trouvé",
  scanError: "Erreur de scan",
  totalCannotBeNegative: "Le total ne peut pas être négatif",
  saleSuccess: "Vente réussie",
  billNotSaved: "Facture non sauvegardée",
  pleasewait: "Veuillez patienter",
  productAdded: "Produit ajouté",
  findBillsError: "Erreur lors de la recherche des factures",
  profileUpdateSuccess: "Profil mis à jour avec succès",
  profileUpdateFailed: "Échec de la mise à jour du profil",
  productUpdateSuccess: "Produit mis à jour avec succès",
  downloadUpdateMessage: "Mise à jour téléchargée, veuillez l'installer",
  iosNoApkSupport:
    "iOS ne prend pas en charge l'installation d'APK, veuillez mettre à jour l'application via le store",
  errorOccurred: "Une erreur s'est produite",
  downloading: "Téléchargement :",
  invoice: "Facture",
  showMore: "Afficher plus",
  newVersionAvailable: "Nouvelle version disponible",
  alreadyLatestVersion: "Vous utilisez déjà la dernière version",
  submissionSuccessful: "Soumission réussie",
  submissionFailed: "Désolé ! Le produit n'a pas été envoyé !",
  unexpectedError:
    "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
  logoutFailed: "Échec de la déconnexion",
  addfaild: "Échec de l'ajout",
  noImage: "Aucune image",
  registrationSuccess: "Inscription réussie !",
  systemConnectionMessage:
    "Votre compte a été créé avec succès. Vous pouvez maintenant vous connecter au système.",
  finish: "Terminer",
  weeklyRevenue: "Chiffre d'affaires hebdomadaire",
  increaseFromLastWeek: "Augmentation de 30% par rapport à la semaine dernière",
  thisWeek: "Cette semaine",
  lastWeek: "Semaine dernière",
  noDataAvailable: "Aucune donnée disponible",
  emailVerified: "Email vérifié avec succès",
  verificationCodeResent:
    "Code de vérification renvoyé. Veuillez vérifier votre email.",
  emailVerificationFailed: "Échec de la vérification de l'email",
  resendVerificationFailed: "Échec du renvoi du code de vérification",
  enterVerificationCode: "Entrez le code de vérification",
  verifyEmail: "Vérifier l'email",
  verifyPasswordReset: "Vérifier la réinitialisation du mot de passe",
  passwordResetVerificationDescription:
    "Nous avons envoyé un code de vérification à votre email pour réinitialiser votre mot de passe. Veuillez entrer le code ci-dessous.",
  passwordResetVerified: "Réinitialisation du mot de passe vérifiée",
  passwordResetSuccess:
    "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
  passwordStrength: "Force du mot de passe",
  atLeast8Characters: "Au moins 8 caractères",
  uppercaseAndLowercase: "Majuscules et minuscules",
  atLeastOneNumber: "Au moins un chiffre",
  sendCode: "Envoyer le code",
  enterCodeAndNewPassword:
    "Entrez le code de vérification et votre nouveau mot de passe",
  backToPreviousStep: "Retour à l'étape précédente",
  resendCode: "Renvoyer le code",
  absoluteUpdateAvailable: "Mise à jour critique disponible",
  updateCheckFailed: "Échec de la vérification des mises à jour",
  noUpdateAvailable: "Aucune mise à jour disponible",
  sales: "Ventes",
  print: "Imprimer",
  products: "Produits",
  subscriptionStatus: "Statut d'abonnement",
  subscriptionType: "Type d'abonnement",
  subscriptionExpiry: "Expiration de l'abonnement",
  upgradeToPremium: "Passer à Premium",
  paymentHistory: "Historique des paiements",
  active: "Actif",
  expired: "Expiré",
  trial: "Essai",
  free: "Gratuit",
  premium: "Premium",
  enterprise: "Entreprise",
  upgradeFeatureComingSoon: "Fonction de mise à niveau bientôt disponible",
  paymentHistoryComingSoon: "Historique des paiements bientôt disponible",
  freeTierLimitExceeded: "Limite du plan gratuit dépassée",
  freeTierLimitMessage:
    "Vous avez atteint les limites de votre plan gratuit. Passez à Premium pour continuer.",
  currentLimits: "Limites actuelles",
  productsLimit: "Produits",
  debtsLimit: "Dettes",
  invoicesLimit: "Factures",
  upgradeNow: "Passer à Premium maintenant",
  continueLater: "Continuer plus tard",
  invalidPhoneNumber:
    "Le numéro de téléphone doit contenir exactement 10 chiffres",
  noChangesToSave: "Aucune modification à sauvegarder",
  notSpecified: "Non spécifié",
  activePaid: "Actif - Payé",
  currentlyUnavailable: "Actuellement indisponible",
  featureUnderDevelopment: "Cette fonctionnalité est en cours de développement",
  verified: "Vérifié",
  pendingVerification: "En attente de vérification",
  startDate: "Date de début",
  selectDateRange: "Sélectionner la période",
  registrationDate: "Date d'inscription",
  location: "Emplacement du magasin",
  unitTypeCannotHavePercentage:
    "Le type d'unité ne peut pas contenir de pourcentage",
  salesMethod: "Méthode de vente",
  sellWithoutScanner: "Vendre sans scanner",
  sellWithoutScannerDesc: "Vente manuelle sans scanner optique",
  sellWithScannerDesc: "Vendre en utilisant le scanner optique",
  closeSalesMethod: "Fermer",
  currentPasswordLabel: "Mot de passe actuel",
  repeatPasswordLabel: "Répéter le mot de passe",
  profile: "Profil",
  totalColon: "Total:",
  arabicLang: "العربية",
  frenchLang: "Français",
  englishLang: "English",
  defaultUsername: "Abdullah",
  defaultLocation: "District de Maysara, Algérie",
  defaultStoreName: "Épicerie",
  enterEmailToResetPassword:
    "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe",
  resetPassword: "Réinitialiser le mot de passe",
  backToLogin: "Retour à la connexion",
  enterEmail: "Entrez votre email",
  tapToRetry: "Appuyez pour réessayer",
  vsLastWeek: "par rapport à la semaine dernière",
  noChange: "Aucun changement par rapport à la semaine dernière",
  showLess: "Afficher moins",
  dzCurrency: "DZD",
  amountFilledFromSale: "Montant rempli depuis la vente",
  kilogram: "Kilogramme",
  liter: "Litre",
  unit: "Unité",
  // Store Categories
  storeCategory: "Catégorie du magasin",
  selectCategory: "Sélectionner une catégorie",
  selectWilaya: "Sélectionner une Wilaya",
  general: "Général",
  grocery: "Épicerie",
  clothing: "Vêtements",
  electronics: "Électronique",
  pharmacy: "Pharmacie",
  bakery: "Boulangerie",
  butchery: "Boucherie",
  hardware: "Quincaillerie",
  stationery: "Papeterie",
  cosmetics: "Cosmétiques",
  toys: "Jouets",
  sports: "Articles de sport",
  // Limits page translations
  limits: "Limites",
  currentLimitsTitle: "Limites actuelles",
  limitsDescription:
    "Voici vos limites actuelles selon votre plan d'abonnement",
  usageLimits: "Limites d'utilisation",
  used: "Utilisé",
  remainingLimit: "Restant",
  unlimited: "Illimité",
  freePlan: "Plan gratuit",
  premiumPlan: "Plan premium",
  productsUsage: "Produits créés",
  debtsUsage: "Dettes enregistrées",
  invoicesUsage: "Factures générées",
  upgradeToGetMore: "Passez au premium pour plus de limites",
  viewLimits: "Voir les limites",
  manageLimits: "Gérer les limites",
  limitsOverview: "Aperçu des limites",
  nearLimit: "Proche de la limite",
  approachingLimit: "Approche de la limite",
  withinLimits: "Dans les limites",
  features: "Fonctionnalités",
  emailVerificationDescription:
    "Nous avons envoyé un code de vérification à votre adresse e-mail. Veuillez entrer le code ci-dessous pour vérifier votre compte.",
  didntReceiveCode: "Vous n'avez pas reçu le code ?",
  pleaseVerifyEmail: "Veuillez vérifier votre email pour continuer",
  emailUpdatedSuccessfully: "Email mis à jour avec succès",
  changingEmailRequiresVerification:
    "Le changement d'email nécessite une vérification",
  emailChangeNote: "Mettez à jour votre adresse email",
  failedToSendVerificationCode: "Échec de l'envoi du code de vérification",
  pleaseEnterComplete6DigitCode: "Veuillez entrer le code à 6 chiffres complet",
  emailVerifiedSuccessfully: "Email vérifié avec succès",
  verificationCodeSent: "Code de vérification envoyé",
  failedToResendCode: "Échec du renvoi du code",
  weHaveSentVerificationCodeTo: "Nous avons envoyé un code de vérification à",
  verificationFailed: "Échec de la vérification",
  weak: "Faible",
  medium: "Moyen",
  strong: "Fort",
  passwordsMatch: "Les mots de passe correspondent",
  changePasswordInfo:
    "Pour votre sécurité, choisissez un mot de passe fort contenant au moins 8 caractères",
  scannerReady: "Scanner prêt - Scannez le code-barres",
  weeklySummary: "Résumé hebdomadaire",
  todaySummary: "Résumé d'aujourd'hui",
  increaseBy: "Augmentation de",
  decreaseBy: "Diminution de",
  comparedToLastWeek: "par rapport à la semaine dernière",
  enterBarcode: "Entrez le code-barres",
  scanBarcode: "Scanner le code-barres",
  subscriptionDate: "Date d'abonnement",
  activateAnnual: "Activer l'abonnement annuel",
  viewFreeLimits: "Voir les limites gratuites",
  updateProfile: "Mettre à jour le profil",
  // Day names
  sunday: "Dimanche",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  // Stats and Dashboard
  custom: "Personnalisé",
  endDate: "Date de fin",
  totalSales: "Ventes totales",
  totalBills: "Nombre de factures",
  debts: "Dettes",
  capital: "Capital",
  soldProducts: "Produits vendus",
  inStock: "En stock",
  profitDA: "Profit (DA)",
  revenue: "Revenu",
  date: "Date",
  product: "Produit",
  salesCount: "Nombre de ventes",
  totalProfit: "Profit total",
  totalCapital: "Capital total",
  downloadApp: "Téléchargez l'application",
  smallScreenMessage:
    "Pour une meilleure expérience sur votre téléphone, téléchargez notre application depuis le Play Store.",
  downloadFromPlayStore: "Télécharger depuis Play Store",
  getItOn: "TÉLÉCHARGER SUR",
  googlePlay: "Google Play",
  continueOnWeb: "Continuer sur le site web",
  verifyEmailReminder:
    "💡 Conseil : Vérifiez votre email depuis votre profil pour sécuriser votre compte",
  verify: "Vérifier",
  resend: "Renvoyer",
  sentTo: "Envoyé à",
  // Notifications
  notifications: "Notifications",
  noNotifications: "Aucune notification pour le moment",
  deleteNotification: "Supprimer la notification",
  deleteNotificationConfirm: "Voulez-vous supprimer cette notification ?",
  justNow: "À l'instant",
  markAllRead: "Tout marquer comme lu",
  adminAccessOnly: "Accès administrateur",
  adminRedirectMessage:
    "Ce compte est réservé à l'administration. Veuillez vous connecter via le panneau d'administration sur khdame.com/admin/login",
  openAdminPanel: "Ouvrir le panneau admin",
  // Missing keys
  activeDebts: "Dettes actives",
  addNewDebt: "Ajouter une dette",
  allBills: "Toutes les factures",
  contactUsForUpgrade: "Contactez-nous pour passer à la version premium",
  dashboard: "Tableau de bord",
  debtDetails: "Détails de la dette",
  debtsCount: "Nombre de dettes",
  details: "Détails",
  noDebts: "Aucune dette",
  payDebt: "Payer la dette",
  pleaseLoginManually: "Veuillez vous connecter manuellement",
  pressBackAgainToExit: "Appuyez à nouveau pour quitter",
  productsCount: "Nombre de produits",
  productsInStock: "Produits en stock",
  quickActions: "Actions rapides",
  repeatpassword: "Répéter le mot de passe",
  salesOperations: "Opérations de vente",
  signupDesc: "Créez votre nouveau compte sur Khadam",
  summary: "Résumé",
  upgradeRequired: "Veuillez passer à la version premium pour continuer.",
};

const ar = {
  pleaseLogin: "يرجى تسجيل الدخول",
  takePhoto: "التقط صورة",
  weekrecap: "ملخص الأسبوع",
  sellQuantity: "نسبة المبيعات",
  noImageSelected: "لم يتم اختيار صورة",
  imageSelected: "تم اختيار الصورة",
  errorsearch: "خطأ في البحث",
  all_products: "جميع المنتجات",
  low_stock: "مخزون منخفض (≤10)",
  high_value: "قيمة عالية (≥100)",
  sort_by: "ترتيب حسب:",
  name_asc: "الاسم (أ-ي)",
  name_desc: "الاسم (ي-أ)",
  price_asc: "السعر (منخفض إلى مرتفع)",
  price_desc: "السعر (مرتفع إلى منخفض)",
  stock_asc: "المخزون (قليل إلى كثير)",
  stock_desc: "المخزون (كثير إلى قليل)",
  orders: "الطلبات",
  noOrders: "لا توجد طلبات حاليا",
  noOrdersDesc: "ستظهر طلبات العملاء هنا",
  orderConfirmed: "مؤكد",
  orderPending: "قيد الانتظار",
  confirmOrder: "تأكيد",
  cancelOrder: "إلغاء",
  deleteOrder: "حذف",
  orderConfirmedSuccess: "تم تأكيد الطلب",
  orderCancelledSuccess: "تم إلغاء الطلب",
  orderDeletedSuccess: "تم حذف الطلب",
  orderError: "خطأ في التحديث",
  clientName: "اسم العميل",
  clientPhone: "الهاتف",
  newOrder: "طلب جديد",
  newOrderMessage: "لقد تلقيت طلبًا جديدًا من",
  filterAll: "الكل",
  filterPending: "قيد الانتظار",
  filterConfirmed: "مؤكدة",
  orderDetails: "تفاصيل الطلب",
  product: "المنتج",
  unitPrice: "سعر الوحدة",
  totalPrice: "السعر الإجمالي",
  orderDate: "تاريخ الطلب",
  status: "الحالة",
  actions: "الإجراءات",
  clientLocation: "موقع الزبون",
  close: "إغلاق",
  scanner: "الماسح الضوئي",
  bills: "الفواتير",
  statistics: "الإحصائيات",
  start: "البداية",
  scannerwithout: "بيع بدون مسح",
  welcomeTitle: "مرحبا بك في خدام",
  welcomeDescription: "تنظيم البيع، التخزين والاحصائيات بهاتفك فقط",
  scannerTitle: "بيع بالماسح",
  scannerDescription:
    "قم بإدارة المبيعات بسهولة عبر مسح المنتجات في كل عملية بيع",
  inventoryTitle: "إدارة المخزون",
  inventoryDescription:
    "قم بتنظيم مخزونك بكل سهولة عبر التطبيق، حيث يمكنك إضافة منتجاتك ومتابعة الكميات المتوفرة في أي وقت.",
  register: "تسجيل جديد",
  createAccount: "إنشاء حساب",
  signup: "تسجيل جديد",
  signupTitle: "إنشاء حساب",
  registrationSuccessful: "تم التسجيل بنجاح! مرحباً بك",
  pleaseLoginManually: "يرجى تسجيل الدخول يدوياً",
  username: "اسم المستخدم",
  viewProfile: "عرض الملف الشخصي",
  repeatPassword: "تكرار كلمة المرور",
  storeName: "اسم المتجر",
  storeDescription: "وصف المتجر",
  defaultStoreDescription: "اكتب وصفاً موجزاً لمتجرك...",
  alreadyHaveAccount: "لديك حساب بالفعل ؟",
  signIn: "تسجيل الدخول",
  loginTitle: "تسجيل الدخول",
  forgotPassword: "هل نسيت كلمة المرور ؟",
  orContinueWith: "أو تابع باستخدام",
  googleSignIn: "المتابعة باستخدام Google",
  googleSignInError: "خطأ في تسجيل الدخول بواسطة Google",
  googleSignInCancelled: "تم إلغاء تسجيل الدخول بواسطة Google",
  language: "اللغة",
  emailAlreadyExists: "البريد الإلكتروني موجود بالفعل!",
  totalsells: "إجمالي المبيعات",
  errorFetchingProducts: "حدث خطأ أثناء تحميل المنتجات",
  totalrevenue: "إجمالي الإيرادات",
  totalprofit: "إجمالي الربح",
  totalcapital: "إجمالي رأس المال",
  period: "الفترة",
  nobills: "لا توجد فواتير",
  tout: "الكل",
  today: "اليوم",
  yesterday: "أمس",
  older: "أقدم",
  mounth: "الشهر",
  year: "السنة",
  chooseOption: "اختر خيارا",
  chooseFromGallery: "اختر من المعرض",
  cancel: "الغاء",
  editdain: "تعديل الدين",
  productdetails: "معلومات عن المنتج",
  errorwhilepaying: "حدث خطأ أثناء الدفع",
  dettehasbeendeleted: "تم حذف الدين بنجاح",
  dettehasbeenpaid: "تم دفع الدين بنجاح",
  listofdette: "قائمة الديون",
  calender: "التاريخ :",
  sellseccess: "تمت عملية البيع بنجاح",
  validevalueerror: "الرجاء ادخال قيمة صحيحة",
  fourni: "موزع",
  addtodeptlist: "اضافة الى قائمة الديون",
  paidamount: "المبلغ المدفوع",
  remaining: "المتبقي",
  paymentStatus: "حالة الدفع",
  paid: "مدفوع",
  typeOfQuantity: "نوع الكمية",
  quantity: "الكمية",
  billLoadingDelete: "جاري حذف الفاتورة",
  nodata: "لا توجد بيانات",
  loading: "جاري التحميل",
  addfaild: "فشل في الاضافة",
  addsuccess: "تمت الاضافة بنجاح",
  addnewdette: "اضافة دين جديد",
  updatdette: "تحديث الدين",
  credit: "الديون",
  nameofdain: "اسم المدين",
  phonenumber: "رقم الهاتف",
  quantityofdette: "كمية الدين",
  deletedette: "حذف الدين",
  sales: "المبيعات",
  searchadate: "ابحث بالاسم أو رقم الهاتف",
  welcome: "أهلاً وسهلاً",
  fillall: "يجب عليك ملء جميع الحقول",
  validphone: "الرجاء ادخال قيمة صحيحة",
  nameofdetn: "اسم المدين",
  end: "النهاية",
  adddate: "اضافة مدين",
  manageStockDesc: "قم بإدارة مخزون منتجاتك فقط باستخدام هاتفك",
  skip: "تخطي",
  manageStock: "إدارة المخزون",
  scaneasyDesc:
    "امسح رمز الاستجابة السريعة للمنتجات للحصول على جميع المعلومات وبيعها للعملاء",
  scaneasy: "مسح بسهولة",
  welcomeIntoDesc1: "تطبيق سهل لإدارة مخزون المنتجات",
  welcomeInTo: "مرحبا بك في خدام",
  total: "المجموع",
  next: "التالي",
  sellWithout: "بيع بدون مسح",
  sellWith: "بيع بمسح",
  dateofdette: "تاريخ الدين",
  nbrofoperations: "عمليات التدين",
  profit: "أرباح",
  showless: "عرض اقل",
  nbrofsell: "مرات البيع",
  new: "بيع جديد",
  bill: "الفاتورة",
  searchInvoice: "بحث عن فاتورة",
  invoiceNumber: "فاتورة رقم",
  customerInfo: "معلومات العميل",
  customerName: "اسم العميل",
  phone: "الهاتف",
  phoneNumber: "رقم الهاتف",
  phoneRequired: "رقم الهاتف مطلوب",
  items: "العناصر",
  orderSummary: "ملخص الطلب",
  subtotal: "المجموع الفرعي",
  tax: "الضريبة",
  discount: "الخصم",
  processing: "جاري المعالجة...",
  confirmPurchase: "تأكيد الشراء",
  currency: "دج",
  closeCamera: "غلق الكاميرا",
  totalAmount: "المجموع",
  searchForProduct: "بحث عن المنتج",
  addProduct: "إضافة",
  unregisteredProduct: "منتج غير مسجل",
  sellWithoutScan: "بيع بدون مسح",
  confirm: "تأكيد",
  addToDebtList: "إضافة لقائمة الدين",
  login: "تسجيل الدخول",
  repeatpassword: "تكرار كلمة المرور الجديدة",
  logout: "تسجيل الخروج",
  loginDesc: "سجل الدخول إلى حسابك الحالي في خدام",
  email: "البريد الإلكتروني",
  password: "أدخل كلمة المرور",
  donthaveaccount: "ليس لديك حساب؟",
  contactus: "تواصل معنا",
  changelanguage: "تغيير اللغة",
  newpassword: "كلمة المرور الجديدة",
  openCamera: "فتح الكاميرا",
  oldpassword: "ادخل كلمة المرور القديمة",
  barcodeReading: "قراءة الباركود",
  doubleTapToFlip: "انقر مرتين لقلب الكاميرا",
  frontCameraWarning:
    "قد لا تتمكن الكاميرا الأمامية من التركيز بشكل صحيح على الباركود",
  useBackCamera:
    "انقر مرتين للتبديل إلى الكاميرا الخلفية للحصول على نتائج أفضل",
  successScan: "تم المسح بنجاح",
  delete: "حذف",
  usecanupatehere: "يمكنك تحديث بياناتك هنا",
  save: "حفظ",
  mail: "البريد الإلكتروني",
  callus: "اتصل بنا",
  stock: "المخزون",
  contactusDesc:
    "لا تتردد في الاتصال بنا للحصول على : المساعدة , فتح حساب , الاستفسارات حول تطبيق خدام أو الخدمات التي نقدمها عبر البريد الإلكتروني أو الهاتف.",
  choice: "الرجاء اختيار العملية",
  stats: "احصائيات",
  settings: "اعدادات",
  search: "البحث عن منتج",
  searchByDate: "بحث",
  sell: "بيع جديد",
  addproduct: "اضافة منتج",
  editproduct: "تعديل",
  productavailable: "متوفر",
  budget: "راس المال",
  allbills: "جميع الفواتير",
  showmore: "عرض المزيد",
  productname: "اسم المنتج",
  boughtprice: "سعر الشراء",
  sellprice: "سعر البيع",
  price: "السعر",
  develop: "طور متجرك مع",
  khdame: "خدام",
  welcomedesc1: "استكشف متجرك باستخدام تطبيقنا التفاعلي",
  welcomedesc2: "السهل الاستخدام والمريح للمستخدم",
  noproducts: "لا توجد منتجات",
  noProductsWithoutBarcode: "لا توجد منتجات بدون باركود",
  productName: "اسم المنتج",
  buyPrice: "سعر الشراء",
  sellPrice: "سعر البيع",
  productnotExist: "منتج غير مسجل",
  updateapp: "تحديث التطبيق",
  changedata: "تغيير البيانات",
  barcode: "الباركود",
  scanNew: "مسح جديد",
  alreadyScanned: "تم المسح",
  scanProduct: "مسح المنتج",
  addpicture: "اضافة صورة",
  changeProfilePhoto: "تغيير صورة الملف الشخصي",
  profilePhotoUpdated: "تم تحديث صورة الملف الشخصي",
  profilePhotoFailed: "فشل تحديث الصورة",
  scanBarcode: "مسح الباركود",
  comptepersonel: "الحساب الشخصي",
  storeInfo: "معلومات المتجر",
  add: "اضافة",
  clickToAdd: "اضغط للإضافة",
  searchError: "خطأ في البحث عن المنتجات",
  newsell: "بيع جديد",
  storename: "اسم المتجر",
  changepassword: "تغيير كلمة المرور",
  mailRequired: "البريد الإلكتروني مطلوب",
  passwordRequired: "كلمة المرور مطلوبة",
  usernameRequired: "اسم المستخدم مطلوب",
  storeNameRequired: "اسم المتجر مطلوب",
  passwordsNotMatch: "كلمات المرور غير متطابقة",
  passwordCannotBeSame:
    "كلمة المرور الجديدة يجب أن تكون مختلفة عن كلمة المرور الحالية",
  fillAllFields: "يرجى ملء جميع الحقول",
  passwordMinLength: "كلمة السر يجب ان تكون 5 احرف على الاقل",
  passwordChangeSuccess: "تم تغيير كلمة السر بنجاح",
  changePasswordError: "حدث خطا",
  cameraPermission: "صلاحيات الكاميرا",
  cameraPermissionRequest: "سنحتاج الى اذنك لاستخدام الكاميرا",
  grantPermission: "اعطاء الاذن",
  currentPassword: "كلمة المرور الحالية",
  newPassword: "كلمة المرور الجديدة",
  confirmPassword: "إعادة كلمة المرور",
  changePassword: "تغيير كلمة المرور",
  invalidEmail: "بريد إلكتروني غير صالح",
  currentversion: "الاصدار الحالي",
  updateNewVersion: "تحميل الاصدار الجديد",
  updateSuccess: "تم التعديل بنجاح",
  updateFailed: "فشل في التعديل",
  priceValidation: "سعر البيع يجب ان يكون اكبر من سعر الشراء",
  searchProduct: "البحث عن منتج",
  editProduct: "تعديل المنتج",
  deleteProduct: "حذف المنتج",
  confirmDelete: "هل أنت متأكد من حذف هذا المنتج؟",
  deleteMessage:
    "هل أنت متأكد من حذف هذه الفاتورة؟ هذا الإجراء لا يمكن التراجع عنه.",
  productDeleted: "تم حذف المنتج بنجاح",
  deleteFailed: "فشل في الحذف",
  stockManagement: "إدارة المخزون",
  addNewProduct: "إضافة منتج جديد",
  loginSuccess: "تم الدخول بنجاح",
  loadProductsError: "خطأ في تحميل المنتجات",
  productAdded: "تم إضافة المنتج",
  noProductsFound: "لم يتم العثور على منتجات",
  searchProductsError: "خطأ في البحث عن المنتجات",
  quantityUpdated: "تم تحديث الكمية بنجاح",
  enterValidQuantity: "الرجاء ادخال كمية صحيحة",
  notEnoughStock: "لا توجد كمية كافية في المخزون",
  productAddedSuccess: "تمت اضافة المنتج بنجاح",
  enterValidValue: "الرجاء ادخال قيمه صحيحه",
  totalCannotBeNegative: "لا يمكن ان يكون المجموع سالبا",
  saleSuccess: "تم البيع بنجاح",
  billNotSaved: "هناك خطا الفاتوره لم تخزن",
  scanSuccess: "تم المسح بنجاح",
  productNotFound: "المنتج غير موجود",
  scanError: "حدث خطأ أثناء المسح",
  findBillsError: "خطا في ايجاد الفاتورات",
  deleteSuccess: "تم الحذف بنجاح",
  deleteError: "هناك خطا",
  newVersionAvailable: "هناك اصدار جديد",
  alreadyLatestVersion: "أنت تستعمل النسخة الحديثة",
  logoutFailed: "فشل في تسجيل الخروج",
  submissionSuccessful: "تم الإرسال بنجاح",
  submissionFailed: "عذراً! لم يتم إرسال المنتج!",
  unexpectedError: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.",
  profileUpdateSuccess: "تم تغيير المعلومات بنجاح",
  profileUpdateFailed: "فشل في حفظ البيانات",
  productUpdateSuccess: "تم تعديل المنتج بنجاح",
  downloadUpdateMessage: "تم تنزيل التحديث، يرجى تثبيته",
  iosNoApkSupport: "لا يدعم iOS تثبيت ملفات APK، يرجى تحديث التطبيق عبر المتجر",
  errorOccurred: "حدث خطأ",
  downloading: "جاري التحميل :",
  invoice: "فاتورة",
  showMore: "عرض المزيد",
  whatsapp: "واتساب",
  facebook: "فيسبوك",
  instagram: "انستغرام",
  website: "موقع الويب",
  call: "اتصال",
  emailContact: "البريد الإلكتروني",
  enterUsername: "أدخل اسم المستخدم",
  usernameOrEmail: "اسم المستخدم أو البريد الإلكتروني",
  enterUsernameOrEmail: "أدخل اسم المستخدم أو البريد الإلكتروني",
  usernameOrEmailRequired: "اسم المستخدم أو البريد الإلكتروني مطلوب",
  enterEmail: "أدخل البريد الإلكتروني",
  enterStoreName: "أدخل اسم المتجر",
  enterPhoneNumber: "أدخل رقم الهاتف",
  enterStoreLocation: "أدخل موقع المتجر",
  imageSizeError: "يجب أن يكون حجم الصورة أقل من 600 كيلوبايت",
  pleasewait: "الرجاء الانتظار",
  noImage: "لا توجد صورة",
  registrationSuccess: "تم تسجيل معلوماتك!",
  systemConnectionMessage:
    "تم إنشاء حسابك بنجاح. يمكنك الآن الدخول إلى النظام.",
  finish: "إنهاء",
  weeklyRevenue: "15,350 دج",
  increaseFromLastWeek: "زيادة ب 30% عن الاسبوع الماضي",
  thisWeek: "هذا الاسبوع",
  lastWeek: "الاسبوع الماضي",
  noDataAvailable: "لا توجد بيانات متاحة",
  emailVerified: "تم التحقق من البريد الإلكتروني بنجاح",
  verificationCodeResent:
    "تم إرسال رمز التحقق مرة أخرى. يرجى التحقق من بريدك الإلكتروني.",
  emailVerificationFailed: "فشل في التحقق من البريد الإلكتروني",
  resendVerificationFailed: "فشل في إعادة إرسال رمز التحقق",
  enterVerificationCode: "أدخل رمز التحقق",
  verifyEmail: "التحقق من البريد الإلكتروني",
  verifyPasswordReset: "تحقق من إعادة تعيين كلمة المرور",
  passwordResetVerificationDescription:
    "لقد أرسلنا رمز التحقق إلى بريدك الإلكتروني لإعادة تعيين كلمة المرور. الرجاء إدخال الرمز أدناه.",
  passwordResetVerified: "تم التحقق من إعادة تعيين كلمة المرور",
  passwordResetSuccess:
    "تم إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.",
  passwordStrength: "قوة كلمة المرور",
  atLeast8Characters: "8 أحرف على الأقل",
  uppercaseAndLowercase: "أحرف كبيرة وصغيرة",
  atLeastOneNumber: "رقم واحد على الأقل",
  sendCode: "إرسال الرمز",
  enterCodeAndNewPassword: "أدخل رمز التحقق وكلمة المرور الجديدة",
  backToPreviousStep: "العودة للخطوة السابقة",
  resendCode: "إعادة إرسال الرمز",
  absoluteUpdateAvailable: "تحديث هام متاح",
  updateCheckFailed: "فشل في فحص التحديثات",
  noUpdateAvailable: "لا توجد تحديثات متاحة",
  subscriptionStatus: "حالة الاشتراك",
  subscriptionType: "نوع الاشتراك",
  subscriptionExpiry: "تاريخ انتهاء الاشتراك",
  upgradeToPremium: "ترقية إلى النسخة المميزة",
  paymentHistory: "سجل المدفوعات",
  active: "نشط",
  expired: "منتهي الصلاحية",
  trial: "تجريبي",
  free: "مجاني",
  premium: "مميز",
  enterprise: "مؤسسي",
  upgradeFeatureComingSoon: "ميزة الترقية قريباً",
  paymentHistoryComingSoon: "سجل المدفوعات قريباً",
  freeTierLimitExceeded: "تم تجاوز حد الخطة المجانية",
  freeTierLimitMessage:
    "لقد وصلت إلى حدود خطتك المجانية. قم بالترقية إلى النسخة المميزة للمتابعة.",
  currentLimits: "الحدود الحالية",
  productsLimit: "المنتجات",
  debtsLimit: "الديون",
  invoicesLimit: "الفواتير",
  upgradeNow: "ترقي إلى النسخة المميزة الآن",
  continueLater: "متابعة لاحقاً",
  invalidPhoneNumber: "رقم الهاتف يجب أن يحتوي على 10 أرقام بالضبط",
  noChangesToSave: "لم يتم تغيير أي بيانات",
  notSpecified: "غير محدد",
  activePaid: "نشط - مدفوع",
  currentlyUnavailable: "غير متاح حالياً",
  featureUnderDevelopment: "هذه الميزة قيد التطوير",
  verified: "تم التحقق",
  pendingVerification: "في انتظار التحقق",
  startDate: "تاريخ البدء",
  selectDateRange: "اختر الفترة",
  registrationDate: "تاريخ التسجيل",
  location: "موقع المتجر",
  unitTypeCannotHavePercentage: "نوع الوحدة لا يمكن أن يحتوي على نسب مئوية",
  salesMethod: "طريقة البيع",
  sellWithoutScanner: "البيع بدون ماسح",
  sellWithoutScannerDesc: "البيع اليدوي بدون ماسح ضوئي",
  sellWithScannerDesc: "البيع باستخدام الماسح الضوئي",
  closeSalesMethod: "إغلاق",
  currentPasswordLabel: "كلمة المرور الحالية",
  repeatPasswordLabel: "إعادة كلمة المرور",
  profile: "الملف الشخصي",
  totalColon: "المجموع:",
  print: "طباعة",
  products: "المنتجات",
  arabicLang: "العربية",
  frenchLang: "Français",
  englishLang: "English",
  defaultUsername: "عبدالله",
  defaultLocation: "حي الميسرة الجزائر",
  defaultStoreName: "البقالة",
  enterEmailToResetPassword:
    "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابط لإعادة تعيين كلمة المرور",
  resetPassword: "إعادة تعيين كلمة المرور",
  backToLogin: "العودة لتسجيل الدخول",
  tapToRetry: "اضغط للمحاولة مرة أخرى",
  vsLastWeek: "عن الأسبوع الماضي",
  noChange: "لا تغيير من الأسبوع الماضي",
  showLess: "عرض القليل",
  dzCurrency: "دج",
  amountFilledFromSale: "تم ملء المبلغ من البيع",
  kilogram: "كيلوغرام",
  liter: "لتر",
  unit: "وحدة",
  // Store Categories
  storeCategory: "صنف المتجر",
  selectCategory: "اختر الصنف",
  selectWilaya: "اختر الولاية",
  general: "عام",
  grocery: "بقالة",
  clothing: "ملابس",
  electronics: "إلكترونيات",
  pharmacy: "صيدلية",
  bakery: "مخبزة",
  butchery: "جزارة",
  hardware: "أدوات منزلية",
  stationery: "مكتبة",
  cosmetics: "مستحضرات تجميل",
  toys: "ألعاب",
  sports: "رياضة",
  // Limits page translations
  limits: "الحدود",
  currentLimitsTitle: "الحدود الحالية",
  limitsDescription: "إليك حدودك الحالية حسب خطة الاشتراك الخاصة بك",
  usageLimits: "حدود الاستخدام",
  used: "مُستخدم",
  remainingLimit: "متبقي",
  unlimited: "غير محدود",
  freePlan: "الخطة المجانية",
  premiumPlan: "الخطة المميزة",
  productsUsage: "المنتجات المُنشأة",
  debtsUsage: "الديون المُسجلة",
  invoicesUsage: "الفواتير المُنشأة",
  upgradeToGetMore: "ترقي إلى المميز للحصول على حدود أكثر",
  viewLimits: "عرض الحدود",
  manageLimits: "إدارة الحدود",
  limitsOverview: "نظرة عامة على الحدود",
  nearLimit: "قريب من الحد",
  approachingLimit: "يقترب من الحد",
  withinLimits: "ضمن الحدود",
  features: "مميزات",
  emailVerificationDescription:
    "لقد أرسلنا رمز التحقق إلى بريدك الإلكتروني. الرجاء إدخال الرمز أدناه للتحقق من حسابك.",
  didntReceiveCode: "لم تتلق الرمز؟",
  pleaseVerifyEmail: "يرجى التحقق من بريدك الإلكتروني للمتابعة",
  emailUpdatedSuccessfully: "تم تحديث البريد الإلكتروني بنجاح",
  changingEmailRequiresVerification: "تغيير البريد الإلكتروني يتطلب التحقق",
  emailChangeNote: "حدّث عنوان بريدك الإلكتروني",
  failedToSendVerificationCode: "فشل في إرسال رمز التحقق",
  pleaseEnterComplete6DigitCode: "الرجاء إدخال الرمز المكون من 6 أرقام كاملاً",
  emailVerifiedSuccessfully: "تم التحقق من البريد الإلكتروني بنجاح",
  verificationCodeSent: "تم إرسال رمز التحقق",
  failedToResendCode: "فشل في إعادة إرسال الرمز",
  weHaveSentVerificationCodeTo: "لقد أرسلنا رمز التحقق إلى",
  verificationFailed: "فشل التحقق",
  weak: "ضعيف",
  medium: "متوسط",
  strong: "قوي",
  passwordsMatch: "كلمات المرور متطابقة",
  changePasswordInfo:
    "من أجل أمانك، اختر كلمة مرور قوية تحتوي على 8 أحرف على الأقل",
  verifyEmailReminder:
    "💡 نصيحة: قم بتأكيد بريدك الإلكتروني من ملفك الشخصي لتأمين حسابك",
  upgradeRequired: "يرجى الترقية إلى الإصدار المميز للمتابعة.",
  contactUsForUpgrade:
    "تواصل معنا الان لشراء الاشتراك والحصول على حساب غير محدود!",
  details: "التفاصيل",
  pressBackAgainToExit: "اضغط مرة أخرى للخروج",
  image: "صورة المنتج",
  dashboard: "لوحة التحكم",
  quickActions: "إجراءات سريعة",
  revenue: "المدخول",
  date: "التاريخ",
  product: "المنتج",
  salesCount: "عمليات البيع",
  summary: "ملخص",
  productsInStock: "منتج في المخزون",
  salesOperations: "عملية بيع",
  activeDebts: "دين نشط",
  weeklySummary: "ملخص الأسبوع",
  todaySummary: "ملخص اليوم",
  scannerReady: "الماسح جاهز - قم بمسح الباركود",
  increaseBy: "زيادة ب",
  decreaseBy: "انخفاض ب",
  comparedToLastWeek: "عن الاسبوع الماضي",
  enterBarcode: "أدخل الباركود",
  addNewDebt: "إضافة دين جديد",
  payDebt: "دفع الدين",
  signupDesc: "أنشئ حسابك الجديد على خدام",
  allBills: "جميع الفواتير",
  noDebts: "لا توجد ديون",
  debtDetails: "تفاصيل الدين",
  productsCount: "عدد المنتجات",
  debtsCount: "عدد الديون",
  subscriptionDate: "تاريخ الاشتراك",
  activateAnnual: "تفعيل الاشتراك السنوي",
  viewFreeLimits: "عرض حدود النسخة المجانية",
  updateProfile: "تحديث الملف الشخصي",
  // Day names
  sunday: "الأحد",
  monday: "الإثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  // Stats and Dashboard
  custom: "مخصص",
  endDate: "إلى تاريخ",
  totalSales: "إجمالي المبيعات",
  totalBills: "عدد الفواتير",
  debts: "الديون",
  capital: "رأس المال",
  soldProducts: "تم البيع",
  inStock: "في المخزون",
  profitDA: "الربح (دج)",
  totalProfit: "إجمالي الربح",
  totalCapital: "إجمالي رأس المال",
  downloadApp: "حمّل التطبيق",
  smallScreenMessage:
    "للحصول على تجربة أفضل على هاتفك، حمّل تطبيقنا من Play Store.",
  downloadFromPlayStore: "تحميل من Play Store",
  getItOn: "حمّل من",
  googlePlay: "جوجل بلاي",
  continueOnWeb: "متابعة على الموقع",
  verify: "تحقق",
  resend: "إعادة إرسال",
  sentTo: "تم الإرسال إلى",
  // Notifications
  notifications: "الإشعارات",
  noNotifications: "لا توجد إشعارات حتى الآن",
  deleteNotification: "حذف الإشعار",
  deleteNotificationConfirm: "هل تريد حذف هذا الإشعار؟",
  justNow: "الآن",
  markAllRead: "تعليم الكل كمقروء",
  adminAccessOnly: "وصول المسؤول",
  adminRedirectMessage:
    "هذا الحساب مخصص للإدارة. يرجى تسجيل الدخول عبر لوحة الإدارة على khdame.com/admin/login",
  openAdminPanel: "فتح لوحة الإدارة",
  // Missing keys
  pleaseaddproducts: "يرجى إضافة المنتجات",
};

const en = {
  welcome: "Welcome",
  login: "Login",
  pleaseLogin: "Please login",
  logout: "Logout",
  loginDesc: "Sign in to your existing account on Khadam",
  email: "Email",
  password: "Enter your password",
  donthaveaccount: "Don't have an account?",
  contactus: "Contact us",
  changelanguage: "Change language",
  mail: "Email",
  callus: "Call us",
  stock: "Stock",
  welcomeInTo: "Welcome to Khdame",
  choice: "Please choose the operation",
  takePhoto: "Take photo",
  stats: "Statistics",
  settings: "Settings",
  sell: "Sell",
  addproduct: "Add product",
  currentversion: "Current version",
  search: "Search for product",
  searchByDate: "Search",
  editproduct: "Edit",
  productavailable: "Stock",
  budget: "Budget",
  productname: "Product name",
  boughtprice: "Purchase",
  sellprice: "Sale",
  price: "Price",
  develop: "Develop your store with",
  khdame: "Khdame",
  welcomedesc1: "Discover your store with our interactive application",
  start: "Start",
  welcomedesc2: "Easy to use and user-friendly",
  noproducts: "No products",
  noProductsWithoutBarcode: "No products without barcode",
  errorFetchingProducts: "Error fetching products",
  addProduct: "Add product",
  productName: "Product name",
  bills: "Bills",
  nobills: "No bills",
  allbills: "All bills",
  thisWeek: "This week",
  lastWeek: "Last week",
  findBillsError: "Error loading bills",
  buyPrice: "Purchase price",
  sellPrice: "Sale price",
  typeOfQuantity: "Type of quantity",
  quantity: "Quantity",
  barcode: "Barcode",
  scanNew: "New scan",
  alreadyScanned: "Already scanned",
  scanProduct: "Scan product",
  openCamera: "Open camera",
  barcodeReading: "Barcode reading",
  scanBarcode: "Scan barcode",
  doubleTapToFlip: "Double tap to flip camera",
  frontCameraWarning: "Front camera may not focus properly on barcodes",
  useBackCamera: "Double tap to switch to back camera for better results",
  successScan: "Scan successful",
  delete: "Delete",
  save: "Save",
  closeCamera: "Close camera",
  add: "Add",
  clickToAdd: "Click to add",
  searchError: "Error while searching for products",
  cancel: "Cancel",
  currency: "DA",
  comptepersonel: "Personal Account",
  storeInfo: "Store Info",
  updateapp: "Update",
  storename: "Store name",
  changepassword: "Change password",
  changedata: "Change data",
  newpassword: "New password",
  oldpassword: "Old password",
  confirm: "Confirm",
  username: "Username",
  viewProfile: "View profile",
  repeatPassword: "Repeat password",
  updateNewVersion: "Update",
  period: "Period",
  tout: "All",
  today: "Today",
  yesterday: "Yesterday",
  mounth: "Month",
  total: "Total",
  profit: "Profit",
  year: "Year",
  nbrofsell: "Sales",
  mailRequired: "Email required",
  passwordRequired: "Password required",
  usernameRequired: "Username required",
  storeNameRequired: "Store name required",
  passwordsNotMatch: "Passwords do not match",
  passwordCannotBeSame: "New password must be different from current password",
  fillAllFields: "Please fill all fields",
  passwordMinLength: "Password must contain at least 5 characters",
  passwordChangeSuccess: "Password changed successfully",
  changePasswordError: "An error occurred",
  cameraPermission: "Camera permissions",
  cameraPermissionRequest: "We need your permission to use the camera",
  grantPermission: "Grant permission",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  changePassword: "Change password",
  orderSummary: "Order summary",
  subtotal: "Subtotal",
  tax: "Tax",
  discount: "Discount",
  processing: "Processing...",
  confirmPurchase: "Confirm purchase",
  totalAmount: "Total",
  searchForProduct: "Search for product",
  unregisteredProduct: "Unregistered product",
  sellWithoutScan: "Sell without scan",
  addToDebtList: "Add to debt list",
  new: "New",
  scaneasy: "Scan easily",
  scaneasyDesc:
    "Scan product barcodes to get all information and sell them to customers",
  welcomeIntoDesc1: "Easy application to manage product inventory",
  productnotExist: "Unregistered product",
  manageStock: "Manage stock",
  next: "Next",
  end: "End",
  credit: "Debts",
  manageStockDesc: "Manage your product inventory simply with your phone",
  skip: "Skip",
  usecanupatehere: "You can update your information here",
  contactusDesc:
    "Feel free to contact us for: assistance, account opening, questions about the Khadam application or the services we offer by email or phone.",
  nameofdetn: "Name",
  nbrofoperations: "Number of operations",
  dateofdette: "Debt date",
  listofdette: "Debt list",
  searchadate: "Search by name or number",
  adddate: "Add debtor",
  deletedette: "Delete debt",
  addnewdette: "Add new debt",
  updatdette: "Update debt",
  nameofdain: "Debtor name",
  phonenumber: "Phone number",
  quantityofdette: "Debt amount",
  fillall: "You must fill all fields",
  validphone: "Please enter a valid value",
  addsuccess: "Added successfully",
  loading: "Loading",
  nodata: "No data",
  paidamount: "Paid amount",
  remaining: "Remaining",
  paymentStatus: "Payment status",
  paid: "Paid",
  billLoadingDelete: "Deleting in progress",
  sellWithout: "Sell without scan",
  sellWith: "Sell with scan",
  addtodeptlist: "Add to debt list",
  validevalueerror: "Please enter a valid value",
  fourni: "Supplier",
  pleaseaddproducts: "Please add products",
  sellseccess: "Sale successful",
  calender: "Date:",
  editdain: "Edit debt",
  errorwhilepaying: "An error occurred while paying",
  dettehasbeendeleted: "Debt has been deleted successfully",
  dettehasbeenpaid: "Debt has been paid successfully",
  productdetails: "Product details",
  addpicture: "Add image",
  changeProfilePhoto: "Change profile photo",
  profilePhotoUpdated: "Profile photo updated",
  profilePhotoFailed: "Failed to update photo",
  chooseOption: "Choose option",
  chooseFromGallery: "Choose from gallery",
  imageSelected: "Image selected",
  noImageSelected: "No image selected",
  errorsearch: "Search error",
  weekrecap: "Weekly recap",
  sellQuantity: "Sell quantity",
  all_products: "All products",
  low_stock: "Low stock (≤10)",
  high_value: "High value (≥100)",
  sort_by: "Sort by:",
  name_asc: "Name (A-Z)",
  name_desc: "Name (Z-A)",
  price_asc: "Price (low to high)",
  price_desc: "Price (high to low)",
  stock_asc: "Stock (low to high)",
  stock_desc: "Stock (high to low)",
  orders: "Orders",
  noOrders: "No orders yet",
  noOrdersDesc: "Customer orders will appear here",
  orderConfirmed: "Confirmed",
  orderPending: "Pending",
  confirmOrder: "Confirm",
  cancelOrder: "Cancel",
  deleteOrder: "Delete",
  orderConfirmedSuccess: "Order confirmed",
  orderCancelledSuccess: "Order cancelled",
  orderDeletedSuccess: "Order deleted",
  orderError: "Error updating order",
  clientName: "Client name",
  clientPhone: "Phone",
  newOrder: "New order",
  newOrderMessage: "You received a new order from",
  filterAll: "All",
  filterPending: "Pending",
  filterConfirmed: "Confirmed",
  orderDetails: "Order details",
  product: "Product",
  unitPrice: "Unit price",
  totalPrice: "Total price",
  orderDate: "Order date",
  status: "Status",
  actions: "Actions",
  clientLocation: "Customer location",
  close: "Close",
  scanner: "Scanner",
  statistics: "Statistics",
  scannerwithout: "Scanner without",
  welcomeTitle: "Welcome to your service",
  welcomeDescription:
    "Simple application to manage your store. Organize sales, storage and statistics with just your phone",
  scannerTitle: "Sell with scanner",
  scannerDescription:
    "Easily manage sales by scanning products in each sales operation",
  inventoryTitle: "Inventory management",
  inventoryDescription:
    "Organize your inventory easily via the application where you can add your products and see available quantities at any time.",
  register: "Register",
  createAccount: "Create account",
  signup: "Sign up",
  signupTitle: "Create account",
  registrationSuccessful: "Registration successful! Welcome",
  pleaseLoginManually: "Please login manually",
  storeName: "Store name",
  storeDescription: "Store Description",
  defaultStoreDescription: "Write a brief description of your store...",
  alreadyHaveAccount: "Already have an account?",
  signIn: "Sign in",
  loginTitle: "Login",
  forgotPassword: "Forgot password?",
  orContinueWith: "Or continue with",
  googleSignIn: "Continue with Google",
  googleSignInError: "Google sign-in error",
  googleSignInCancelled: "Google sign-in cancelled",
  language: "Language",
  emailAlreadyExists: "Email already exists!",
  totalsells: "Total sales",
  totalrevenue: "Total revenue",
  totalprofit: "Total profit",
  totalcapital: "Total capital",
  updateSuccess: "Update successful",
  updateFailed: "Update failed",
  priceValidation: "Sale price must be greater than purchase price",
  searchProduct: "Search product",
  editProduct: "Edit product",
  deleteProduct: "Delete product",
  confirmDelete: "Are you sure you want to delete this product?",
  deleteMessage:
    "Are you sure you want to delete this bill? This action cannot be undone.",
  productDeleted: "Product deleted successfully",
  deleteFailed: "Delete failed",
  stockManagement: "Stock management",
  addNewProduct: "Add new product",
  loginSuccess: "Login successful",
  whatsapp: "WhatsApp",
  facebook: "Facebook",
  instagram: "Instagram",
  website: "Website",
  call: "Call",
  emailContact: "Email",
  enterUsername: "Enter username",
  usernameOrEmail: "Username or Email",
  enterUsernameOrEmail: "Enter your username or email",
  usernameOrEmailRequired: "Username or email required",
  enterStoreName: "Enter store name",
  enterPhoneNumber: "Enter phone number",
  enterStoreLocation: "Enter store location",
  imageSizeError: "Image size must be less than 600 KB",
  loadProductsError: "Error loading products",
  quantityUpdated: "Quantity updated successfully",
  enterValidQuantity: "Please enter a valid quantity",
  notEnoughStock: "Not enough stock available",
  productAddedSuccess: "Product added successfully",
  enterValidValue: "Please enter a valid value",
  deleteSuccess: "Deleted successfully",
  deleteError: "Delete error",
  newVersionAvailable: "New version available",
  alreadyLatestVersion: "You are using the latest version",
  submissionSuccessful: "Submission successful",
  submissionFailed: "Sorry! The product was not sent!",
  unexpectedError: "An unexpected error occurred. Please try again later.",
  noProductsFound: "No products found",
  searchProductsError: "Error searching products",
  scanSuccess: "Scan successful",
  productNotFound: "Product not found",
  scanError: "Scan error",
  totalCannotBeNegative: "Total cannot be negative",
  saleSuccess: "Sale successful",
  billNotSaved: "Bill not saved",
  emailVerified: "Email verified successfully",
  verificationCodeResent: "Verification code resent. Please check your email.",
  emailVerificationFailed: "Email verification failed",
  resendVerificationFailed: "Failed to resend verification code",
  enterVerificationCode: "Enter verification code",
  verifyEmail: "Verify email",
  verifyPasswordReset: "Verify Password Reset",
  passwordResetVerificationDescription:
    "We've sent a verification code to your email to reset your password. Please enter the code below.",
  passwordResetVerified: "Password Reset Verified",
  passwordResetSuccess:
    "Your password has been reset successfully. You can now login with your new password.",
  passwordStrength: "Password Strength",
  atLeast8Characters: "At least 8 characters",
  uppercaseAndLowercase: "Uppercase and lowercase",
  atLeastOneNumber: "At least one number",
  sendCode: "Send Code",
  enterCodeAndNewPassword: "Enter verification code and your new password",
  backToPreviousStep: "Back to previous step",
  resendCode: "Resend code",
  absoluteUpdateAvailable: "Critical update available",
  updateCheckFailed: "Update check failed",
  noUpdateAvailable: "No update available",
  sales: "Sales",
  print: "Print",
  products: "Products",
  subscriptionStatus: "Subscription status",
  subscriptionType: "Subscription type",
  subscriptionExpiry: "Subscription expiry",
  upgradeToPremium: "Upgrade to Premium",
  paymentHistory: "Payment history",
  active: "Active",
  expired: "Expired",
  trial: "Trial",
  free: "Free",
  premium: "Premium",
  enterprise: "Enterprise",
  upgradeFeatureComingSoon: "Upgrade feature coming soon",
  paymentHistoryComingSoon: "Payment history coming soon",
  freeTierLimitExceeded: "Free Tier Limit Exceeded",
  freeTierLimitMessage:
    "You have reached the limits of your free plan. Upgrade to Premium to continue.",
  currentLimits: "Current Limits",
  productsLimit: "Products",
  debtsLimit: "Debts",
  invoicesLimit: "Invoices",
  upgradeNow: "Upgrade to Premium Now",
  continueLater: "Continue Later",
  invalidPhoneNumber: "Phone number must be exactly 10 digits",
  noChangesToSave: "No changes to save",
  notSpecified: "Not specified",
  activePaid: "Active - Paid",
  currentlyUnavailable: "Currently unavailable",
  featureUnderDevelopment: "This feature is under development",
  verified: "Verified",
  pendingVerification: "Pending verification",
  startDate: "Start date",
  selectDateRange: "Select date range",
  registrationDate: "Registration date",
  location: "Store location",
  unitTypeCannotHavePercentage: "Unit type cannot contain percentage",
  salesMethod: "Sales method",
  sellWithoutScanner: "Sell without scanner",
  sellWithoutScannerDesc: "Manual selling without optical scanner",
  sellWithScannerDesc: "Sell using optical scanner",
  closeSalesMethod: "Close",
  currentPasswordLabel: "Current password",
  repeatPasswordLabel: "Repeat password",
  profile: "Profile",
  totalColon: "Total:",
  arabicLang: "العربية",
  frenchLang: "Français",
  englishLang: "English",
  defaultUsername: "Abdullah",
  defaultLocation: "Maysara District, Algeria",
  defaultStoreName: "Grocery Store",
  enterEmailToResetPassword:
    "Enter your email address and we'll send you a link to reset your password",
  resetPassword: "Reset Password",
  backToLogin: "Back to Login",
  enterEmail: "Enter your email",
  tapToRetry: "Tap to retry",
  vsLastWeek: "vs last week",
  noChange: "No change from last week",
  showLess: "Show less",
  dzCurrency: "DZD",
  amountFilledFromSale: "Amount filled from sale",
  kilogram: "Kilogram",
  liter: "Liter",
  unit: "Unit",
  // Store Categories
  storeCategory: "Store Category",
  selectCategory: "Select Category",
  selectWilaya: "Select Wilaya",
  general: "General",
  grocery: "Grocery",
  clothing: "Clothing",
  electronics: "Electronics",
  pharmacy: "Pharmacy",
  bakery: "Bakery",
  butchery: "Butchery",
  hardware: "Hardware",
  stationery: "Stationery",
  cosmetics: "Cosmetics",
  toys: "Toys",
  sports: "Sports",
  // Limits page translations
  limits: "Limits",
  currentLimitsTitle: "Current Limits",
  limitsDescription:
    "Here are your current limits based on your subscription plan",
  usageLimits: "Usage Limits",
  used: "Used",
  remainingLimit: "Remaining",
  unlimited: "Unlimited",
  freePlan: "Free Plan",
  premiumPlan: "Premium Plan",
  productsUsage: "Products Created",
  debtsUsage: "Debts Recorded",
  invoicesUsage: "Invoices Generated",
  upgradeToGetMore: "Upgrade to Premium for more limits",
  viewLimits: "View Limits",
  manageLimits: "Manage Limits",
  limitsOverview: "Limits Overview",
  nearLimit: "Near Limit",
  approachingLimit: "Approaching Limit",
  withinLimits: "Within Limits",
  features: "Features",
  emailVerificationDescription:
    "We've sent a verification code to your email address. Please enter the code below to verify your account.",
  didntReceiveCode: "Didn't receive the code?",
  pleaseVerifyEmail: "Please verify your email to continue",
  emailUpdatedSuccessfully: "Email updated successfully",
  changingEmailRequiresVerification: "Changing email requires verification",
  emailChangeNote: "Update your email address",
  failedToSendVerificationCode: "Failed to send verification code",
  pleaseEnterComplete6DigitCode: "Please enter the complete 6-digit code",
  emailVerifiedSuccessfully: "Email verified successfully",
  verificationCodeSent: "Verification code sent",
  failedToResendCode: "Failed to resend code",
  weHaveSentVerificationCodeTo: "We have sent a verification code to",
  verificationFailed: "Verification failed",
  weak: "Weak",
  medium: "Medium",
  strong: "Strong",
  passwordsMatch: "Passwords match",
  changePasswordInfo:
    "For your security, choose a strong password with at least 8 characters",
  verifyEmailReminder:
    "💡 Tip: Verify your email from your profile to secure your account",
  upgradeRequired: "Please upgrade to premium to continue.",
  contactUsForUpgrade:
    "Contact us now to purchase the subscription and get an unlimited account!",
  details: "Details",
  pressBackAgainToExit: "Press back again to exit",
  image: "Product image",
  dashboard: "Dashboard",
  quickActions: "Quick Actions",
  revenue: "Revenue",
  date: "Date",
  product: "Product",
  salesCount: "Sales Count",
  summary: "Summary",
  productsInStock: "Products in Stock",
  salesOperations: "Sales Operation",
  activeDebts: "Active Debt",
  weeklySummary: "Weekly Summary",
  todaySummary: "Today's Summary",
  scannerReady: "Scanner ready - Scan the barcode",
  increaseBy: "Increase by",
  decreaseBy: "Decrease by",
  comparedToLastWeek: "compared to last week",
  addNewDebt: "Add new debt",
  payDebt: "Pay debt",
  signupDesc: "Create your new account on Khadam",
  allBills: "All bills",
  noDebts: "No debts",
  debtDetails: "Debt details",
  productsCount: "Products count",
  debtsCount: "Debts count",
  subscriptionDate: "Subscription date",
  activateAnnual: "Activate annual subscription",
  viewFreeLimits: "View free limits",
  updateProfile: "Update profile",
  // Day names
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  // Stats and Dashboard
  custom: "Custom",
  endDate: "End date",
  totalSales: "Total sales",
  totalBills: "Total bills",
  debts: "Debts",
  capital: "Capital",
  soldProducts: "Sold",
  inStock: "In stock",
  profitDA: "Profit (DA)",
  totalProfit: "Total profit",
  totalCapital: "Total capital",
  searchInvoice: "Search invoice",
  downloadApp: "Download the App",
  smallScreenMessage:
    "For a better experience on your phone, download our app from the Play Store.",
  downloadFromPlayStore: "Download from Play Store",
  getItOn: "GET IT ON",
  googlePlay: "Google Play",
  continueOnWeb: "Continue on website",
  verify: "Verify",
  resend: "Resend",
  sentTo: "Sent to",
  // Notifications
  notifications: "Notifications",
  noNotifications: "No notifications yet",
  deleteNotification: "Delete notification",
  deleteNotificationConfirm: "Delete this notification?",
  justNow: "Just now",
  markAllRead: "Mark all as read",
  adminAccessOnly: "Admin access only",
  adminRedirectMessage:
    "This account is for administration only. Please log in via the admin panel at khdame.com/admin/login",
  openAdminPanel: "Open admin panel",
  // Missing keys
  addfaild: "Failed to add",
  bill: "Bill",
  customerInfo: "Customer info",
  customerName: "Customer name",
  downloadUpdateMessage: "Update downloaded, please install it",
  downloading: "Downloading:",
  enterBarcode: "Enter barcode",
  errorOccurred: "An error occurred",
  finish: "Finish",
  increaseFromLastWeek: "30% increase from last week",
  invalidEmail: "Invalid email",
  invoice: "Invoice",
  invoiceNumber: "Invoice #",
  iosNoApkSupport:
    "iOS does not support APK files, please update from the store",
  items: "Items",
  logoutFailed: "Logout failed",
  newsell: "New sale",
  noDataAvailable: "No data available",
  noImage: "No image",
  older: "Older",
  phone: "Phone",
  phoneNumber: "Phone number",
  phoneRequired: "Phone number required",
  pleasewait: "Please wait",
  productAdded: "Product added",
  productUpdateSuccess: "Product updated successfully",
  profileUpdateFailed: "Failed to update profile",
  profileUpdateSuccess: "Profile updated successfully",
  registrationSuccess: "Registration successful!",
  repeatpassword: "Repeat password",
  showMore: "Show more",
  showless: "Show less",
  showmore: "Show more",
  systemConnectionMessage: "Please make sure you are connected to the internet",
  weeklyRevenue: "Weekly revenue",
};

export { fr, ar, en };
